export enum ContentType {
    VIDEO = 'video',
    IMAGE = 'image',
    BANNER = 'banner',
    TEXT = 'text',
}

export enum ContentKey {
    LOGIN_BACKGROUND = "login_background",
    SIGNUP_BACKGROUND = "signup_background",
    WELCOME_TEXT = "welcome_text",
    HOME_PAGE_BANNER = "home_page_banner",
    POP_UP = 'pop_up'
}

export enum UserRoles {
    EMPLOYEE = 'employee',
    CUSTOMER = 'customer',
    STAFF = 'staff'
}